<script setup>
import { computed, ref } from 'vue'
import { useWindowSize } from '@vueuse/core';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router'
import { Layout} from 'ant-design-vue';
const ALayoutFooter = Layout.Footer;
let route = useRoute()
const { width } = useWindowSize()
const store = useStore();
let showAllrightFooter = computed(() => {
  return route.meta.showAllrightFooter;
})
let downloadCountTail = computed(() => {
  return store.state.downloadCount > 99 ? '' : '+';
})
</script>

<template>
  <div v-if="showAllrightFooter">
    <a-layout-footer class="footer-box">
      <div class="footer-text-box">
        <h4 class="footer-text-h4">可乐AI简历 · 职场精英的共同选择</h4>
        <p class="footer-text-p">一个依托于AI智能算法的专业简历制作工具</p>
      </div>
      <div class="top-selection">
        <div class="frind-box">
          <p class="frind-inner">
            <span><b class="fas fa-paper-plane mr-2"></b>友情链接:</span>
            <a href="http://luckycola.com.cn/" target="_blank">AI智汇工具网</a>
            <a href="http://luckycola.com.cn/public/dist/imageTool.html" target="_blank">可乐改图网</a>
            <a href="https://blog.csdn.net/qq_48896417?type=blog" target="_blank">官方博客</a>
            <a href="https://gitee.com/xiaoz_xiansen" target="_blank">Gitee</a>
          </p>
        </div>
        <p class="allright-text">Copyright © 2023-2025 海南云智创网络科技版权所有(盗版必究) 浙ICP备2023021014号-1 <span class="download-count-span">(已导出简历<span>{{ store.state.downloadCount }}{{ downloadCountTail }}</span>份)</span></p>
      </div>
    </a-layout-footer>
  </div>
</template>

<style scoped lang="less">
.footer-box {
  background: #39394d;
  @apply py-8;
  .footer-text-box {
    font-family: ui-monospace;
    @apply text-center mb-8;
    color: #fff;
    .footer-text-h4 {
      color: #fff;
      font-size: 32px;
      @apply mb-2;
    }
    .footer-text-p {
      font-size: 15px;
    }
    // background: red;
  }
  .top-selection {
    @apply items-center mt-4;
    // background: green;
    margin: 0 auto;
    .frind-box {
      @apply items-center relative;
      @media screen and (max-width: 768px){
        display: none;
      }
      // background: #ff6600;
      height: 22px;
      .frind-inner {
        margin: 0 auto;
        @apply inline-block;
        position: absolute;
        color: #bbb;
        font-size: 13px;
        font-weight: 500;
        left: 50%;
        transform: translateX(-50%);
        // background: #813f14;
        a {
          cursor: pointer;
          &:hover {
            color: #adadad;
          }
          font-size: 13px;
          @apply mx-2;
          color: #bbb;
        }
      }
    }
    .allright-text {
      color: #fff;
      @apply mt-2;
      opacity: 0.5;
      font-size: 13px;
      text-align: center;
      .download-count-span {
        @apply ml-2;
      }
    }
  }
}
</style>
